import React from 'react';
import ContentLoader from 'react-content-loader';

type SkeletonRowsProps = {
  count?: number;
  height?: number;
};

const SkeletonRows: React.FC<SkeletonRowsProps> = (props) => {
  const { count = 3, height = 40 } = props;

  return (
    <>
      {Array(count)
        .fill(null)
        .map((_, i) => (
          <ContentLoader
            key={i}
            width="100%"
            height={height}
            backgroundColor="#e7f1fc"
            foregroundColor="#ffffff"
          >
            <rect x="0" y="0" rx="8" ry="8" width="100%" height={height} />
          </ContentLoader>
        ))}
    </>
  );
};

export default SkeletonRows;
